import { FormikProps } from "formik";

import { AppDispatch } from "../../../store/store";

import { formatPhoneNumber } from "../../../../../MPP-Common-SPA/utils/globalUtility";

export interface HandlerDependencies {
  form: FormikProps<any>;
  dispatch: AppDispatch;
}

export const createPersonalInformationHandlers = ({
  form,
}: HandlerDependencies) => {
  function handleEmailChange(name: string, value: any) {
    const usePersonalEmail = form.values.PaymentInformation.usePersonalEmail;

    const emailValues = {
      paymentInfoEmail: usePersonalEmail
        ? value
        : form.values.PaymentInformation.email,
      paymentInfoConfirmEmail: usePersonalEmail
        ? value
        : form.values.PaymentInformation.confirmEmail,
      email: value,
    };

    form.setFieldValue("PersonalInformation.email", emailValues.email);

    if (form.values.verificationStatus !== 1) {
      form.setFieldValue(
        "PaymentInformation.email",
        emailValues.paymentInfoEmail
      );
      form.setFieldValue(
        "PaymentInformation.confirmEmail",
        emailValues.paymentInfoConfirmEmail
      );
    } else {
      form.setFieldValue("PaymentInformation", {});
    }
  }

  function handlePrimaryContactInfoChange(name: string, value: any) {
    const usePersonalPhoneInPaymentInformation =
      form.values.PaymentInformation.usePersonalNumber;

    const formattedValue =
      name === "mobile" || name === "phone" ? formatPhoneNumber(value) : value;

    const mobile =
      name === "mobile"
        ? formattedValue
        : form.values.PersonalInformation.mobile;
    const phone =
      name === "phone" ? formattedValue : form.values.PersonalInformation.phone;

    switch (name) {
      case "mobile":
        form.setFieldValue("PersonalInformation.mobile", formattedValue);
        break;
      case "phone":
        form.setFieldValue("PersonalInformation.phone", formattedValue);
        break;
    }

    const verificationStatus = form.values.verificationStatus;
    const usePersonalNumberInTemporaryContactInfo =
      form.values.TemporaryContactInfo.usePersonalNumber;

    if (usePersonalNumberInTemporaryContactInfo) {
      setTemporaryContactInformationTempNumberField(mobile, phone);
    }

    if (verificationStatus !== 1 && usePersonalPhoneInPaymentInformation) {
      setPaymentInformationMobileAndPhoneFields(mobile, phone);
    }
  }

  function setTemporaryContactInformationTempNumberField(
    personalMobile: string,
    personalPhone: string
  ) {
    form.setFieldValue(
      "TemporaryContactInfo.tempPhoneNumber",
      personalMobile || personalPhone
    );
  }

  function setPaymentInformationMobileAndPhoneFields(
    personalMobile: string,
    personalPhone: string
  ) {
    form.setFieldValue(
      "PaymentInformation.mobile",
      personalMobile || personalPhone
    );
    form.setFieldValue(
      "PaymentInformation.confirmMobile",
      personalMobile || personalPhone
    );
  }

  return {
    handleEmailChange,
    handlePrimaryContactInfoChange,
  };
};
